(ns app.front.view.admin.commands.change-municipality
  (:require [app.front.ui :as ui]
            [app.front.ui.select :as ui-select]
            [app.front.util :as futil]
            [app.front.view.group.admin.common :as acommon]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(def state-path (rf/path [::state]))

(rf/reg-event-db ::set-workspace-id
  state-path
  (fn [state [_ workspace-id]]
    (-> state
        (assoc :workspace-id workspace-id)
        (dissoc :new-municipality :current-municipality :municipalities))))

(rf/reg-event-db ::set-municipality
  state-path
  (fn [state [_ {:keys [number]}]]
    (assoc state :new-municipality number)))

(rf/reg-sub ::state :-> ::state)

(rf/reg-sub ::municipalities
  :<- [::state]
  :-> :municipalities)

(rf/reg-sub ::fetched?
  :<- [::municipalities]
  (fn [munis _] (boolean (seq munis))))

(rf/reg-sub ::can-change?
  :<- [::state]
  (fn [{:keys [current-municipality new-municipality]} _]
    (not= current-municipality new-municipality)))

(rf/reg-sub ::selected-municipality
  :<- [::state]
  (fn [state _]
    (->> state
         :municipalities
         (filter (comp (partial = (:new-municipality state))
                       :number))
         first)))

(rf/reg-sub ::workspace-id
  :<- [::state]
  :-> :workspace-id)

(rf/reg-event-fx ::fetch-workspace
  (fn [_ [_ workspace-id]]
    {:comm/command {:command    :admin/get-workspace-for-change-municipality
                    :method     :get
                    :data       (util/mmap workspace-id)
                    :on-success [::fetch-workspace.success]}}))

(rf/reg-event-db ::fetch-workspace.success
  (fn [db [_ status {:keys [current-municipality municipalities]}]]
    (if (= 200 status)
      (-> db
          (assoc-in [::state :new-municipality] current-municipality)
          (assoc-in [::state :current-municipality] current-municipality)
          (assoc-in [::state :municipalities] municipalities))
      db)))

(rf/reg-event-fx ::set-workspace-municipality
  (fn [_ [_ workspace-id {new-municipality :number}]]
    {:comm/command {:command    :admin/workspace-change-municipality
                    :data       (util/mmap workspace-id new-municipality)
                    :on-success [::set-workspace-municipality.success new-municipality]
                    :notify     {:success "Municipality changed! Remember to set property/properties on the workspace manually!"}}}))

(rf/reg-event-db ::set-workspace-municipality.success
  state-path
  (fn [state [_ change-to]]
    (assoc state :current-municipality change-to)))


(defn view [match]
  (let [workspace-id          (<sub [::workspace-id])
        fetched?              (<sub [::fetched?])
        selected-municipality (<sub [::selected-municipality])]
    [acommon/admin-page
     (util/mmap {:title "Change workspace municipality"} match)
     [:section
      [:div
       "You can change a workspace from one municipality to another as long as both municipalities are handled by the same authority group. Note that you *must* update workspace location after changing the municipality!"]
      [ui/text-input
       {:value      workspace-id
        :on-change  #(rf/dispatch-sync [::set-workspace-id (futil/tval %)])
        :label-text "Workspace ID"}]
      (cc/button {:on-click #(>evt [::fetch-workspace workspace-id])
                  :disabled fetched?}
                 "Fetch workspace")

      (when fetched?
        [:div.mt-4
         [ui-select/select
          {:id          "set-muni"
           :values      (<sub [::municipalities])
           :select-text "Change to municipality"
           :val->str    :name
           :on-change   #(>evt [::set-municipality %])
           :value       selected-municipality}]
         (cc/button {:on-click #(>evt [::set-workspace-municipality workspace-id selected-municipality])
                     :disabled (not (<sub [::can-change?]))}
                    "Change municipality")])]]))

(def route
  {:name :view/admin.commands.change-workspace-municipality
   :view view})
